import { LEGAL_CONTACT_EMAIL, LEGAL_ENTITY_NAME, LEGAL_GOVERNING_LAW, LEGAL_MIN_AGE } from '../config/legal';
import type { LegalSection } from './legalTypes';

export const termsOfServiceSections: LegalSection[] = [
  {
    title: '1. Agreement',
    paragraphs: [
      `These Terms of Service ("Terms") govern your use of TrackiAI operated by ${LEGAL_ENTITY_NAME}. By creating an account or using the service, you agree to these Terms and our Privacy Policy.`,
    ],
  },
  {
    title: '2. Eligibility',
    paragraphs: [
      `You must be at least ${LEGAL_MIN_AGE} years old to register. Users under 18 should use TrackiAI with parental or guardian guidance. You are responsible for keeping your login credentials secure.`,
    ],
  },
  {
    title: '3. Accounts',
    paragraphs: [
      'You agree to provide accurate registration information. We may suspend or terminate accounts that violate these Terms, pose a security risk, or are used for unlawful purposes.',
    ],
  },
  {
    title: '4. Subscriptions and fees',
    paragraphs: [
      'Some features may require a paid subscription in the future. Where billing applies, prices and renewal terms will be shown at checkout. You may cancel recurring subscriptions according to the instructions provided at that time.',
    ],
  },
  {
    title: '5. Acceptable use',
    paragraphs: ['You must not:'],
    bullets: [
      'Upload false results or impersonate other athletes or officials.',
      'Attempt to access data or accounts without authorisation.',
      'Interfere with the platform, scrape excessively, or introduce malware.',
      'Use the service for harassment, spam, or illegal activity.',
    ],
  },
  {
    title: '6. Athletics data and accuracy',
    paragraphs: [
      'Competition results and analytics are provided for informational purposes. We do not guarantee completeness or official certification of timings. Always verify critical decisions with official meet results and qualified coaches.',
    ],
  },
  {
    title: '7. AI features',
    paragraphs: [
      'TrackiAI and related AI tools generate outputs based on available data and models. Outputs may be incomplete or incorrect and do not constitute professional coaching, medical, or legal advice.',
    ],
  },
  {
    title: '8. Intellectual property',
    paragraphs: [
      'TrackiAI software, branding, and original content are owned by us or our licensors. You retain rights in content you submit, and grant us a licence to use it to operate and improve the service.',
    ],
  },
  {
    title: '9. Disclaimer',
    paragraphs: [
      'The service is provided "as is" to the fullest extent permitted by law. We disclaim warranties of merchantability, fitness for a particular purpose, and non-infringement.',
    ],
  },
  {
    title: '10. Limitation of liability',
    paragraphs: [
      `To the maximum extent permitted by law, ${LEGAL_ENTITY_NAME} is not liable for indirect, incidental, or consequential damages arising from your use of TrackiAI. Our total liability for any claim is limited to the amount you paid us in the twelve months before the claim (or SGD 100 if no payment was made).`,
    ],
  },
  {
    title: '11. Termination',
    paragraphs: [
      'You may stop using the service at any time. We may terminate or suspend access with notice where reasonable, or immediately for serious breaches.',
    ],
  },
  {
    title: '12. Governing law',
    paragraphs: [
      `These Terms are governed by the laws of ${LEGAL_GOVERNING_LAW}. Disputes shall be subject to the exclusive jurisdiction of the courts of ${LEGAL_GOVERNING_LAW}, unless mandatory consumer protection laws require otherwise.`,
    ],
  },
  {
    title: '13. Contact',
    paragraphs: [`Questions about these Terms: ${LEGAL_CONTACT_EMAIL}.`],
  },
];
